module.exports = __webpack_public_path__ + "img/sa.f6d787d6.png";